import { PartialTranslation } from '../translations';

export const no: PartialTranslation = {
  newChat: 'Ny chat',
  search: 'Søk',
  user: 'Bruker',
  settings: 'Innstillinger',
  language: 'Språk',
  getHelp: 'Få hjelp',
  viewAllPlans: 'Se alle planer',
  learnMore: 'Lær mer',
  logOut: 'Logg ut',
  chooseLanguage: 'Выберите язык',
  chooseYourPreferredLanguage: 'Выберите предпочитаемый язык',
  searchLanguages: 'Поиск языков...',
  autoDetect: 'Automatisk påvisning',
  noLanguagesFound: 'Языки не найдены',
  askAnything: 'Spør om hva som helst',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Personlig',
  freePlan: 'Gratis plan',
  current: 'Текущий',
  close: 'Закрыть',
  archive: 'Архивировать',
  delete: 'Удалить',
  confirmDelete: 'Вы уверены, что хотите удалить этот чат?',
  confirmArchive: 'Вы уверены, что хотите архивировать этот чат?',
  deleteCannotUndo: 'Это действие нельзя отменить.',
  archiveCanFind: 'Вы сможете найти его в списке архива после архивирования.',
  
  // 资源面板
  resources: 'Ressurser',
  addResource: 'Legg til ressurs',
  deleteResource: 'Удалить ресурс',
  noMatchingResourcesFound: 'Подходящие ресурсы не найдены',
  noResourcesAvailable: 'Ресурсы недоступны',
  hideResources: 'Скрыть ресурсы',
  showResources: 'Показать ресурсы',
  
  // 聊天输入框
  typeMessage: 'Skriv en melding...',
  thinkingOptions: 'Варианты размышления',
  deleteFile: 'Удалить файл',
  clearSelection: 'Очистить выбор',
  addAttachment: 'Legg til vedlegg',
  sendMessage: 'Send melding',
  
  // 思考模式选项
  deepInsight: 'Глубокое понимание · Поверхностный анализ',
  deepInsightDesc: 'Быстрое понимание ключевых моментов',
  deepExploration: 'Глубокое исследование · Комплексный анализ',
  deepExplorationDesc: 'Многомерное углубленное исследование',
  deepDeconstruction: 'Глубокая деконструкция · Систематический аргумент',
  deepDeconstructionDesc: 'Послойный прогрессивный анализ',
  
  // 写作模式选项
  contractReview: 'Обзор контракта · Выявление рисков',
  contractReviewDesc: 'Анализ пунктов и проверка соответствия',
  textPolish: 'Полировка текста · Профессиональное выражение',
  textPolishDesc: 'Языковая оптимизация и структурная настройка',
  legalDocuments: 'Правовые документы · Стандартный проект',
  legalDocumentsDesc: 'Профессиональное написание правовых документов',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Logg inn',
  register: 'Registrer deg',
  welcomeBack: 'Velkommen til LawHelper',
  loginSubtitle: 'Din AI Juridiske Forskningsassistent',
  continueWithGoogle: 'Fortsett med Google',
  continueWithMicrosoft: 'Fortsett med Microsoft',
  continueWithWeChat: 'Fortsett med WeChat',
  orContinueWith: 'eller fortsett med',
  emailTab: 'E-post',
  phoneTab: 'Telefon',
  emailPlaceholder: 'Skriv inn e-posten din',
  phonePlaceholder: 'Skriv inn telefonnummer',
  codePlaceholder: 'Skriv inn 6-sifret kode',
  sending: 'Sender...',
  verifying: 'Verifiserer...',
  verify: 'Bekreft',
  sendMagicLink: 'Send magisk lenke',
  getVerificationCode: 'Få kode',
  resendCode: 'Send kode på nytt',
  resendIn: 'Send på nytt om',
  magicLinkSent: 'Magisk lenke sendt til e-posten din',
  magicLinkHint: 'Vi sender en sikker lenke til e-posten din',
  otpSent: 'Bekreftelseskode sendt',
  agreeToTerms: 'Ved å fortsette godtar du våre',
  privacyPolicy: 'Personvernpolicy',
  termsOfService: 'Tjenestevilkår',
  and: 'og',
  privacyTitle: 'Ditt personvern er viktig',
  privacyIntro: 'Vi bruker informasjonskapsler og lignende teknologier for å gi deg den beste opplevelsen.',
  essentialCookies: 'Nødvendige informasjonskapsler',
  essentialDesc: 'Kreves for at nettstedet skal fungere',
  analyticsCookies: 'Analytiske informasjonskapsler',
  analyticsDesc: 'Hjelper oss med å forbedre tjenesten',
  marketingCookies: 'Markedsføringsinformasjonskapsler',
  marketingDesc: 'Brukes til personlig innhold',
  acceptAll: 'Godta alle',
  essentialOnly: 'Kun nødvendige',
  customize: 'Tilpass',
  savePreferences: 'Lagre innstillinger',
  back: 'Tilbake',
  readPrivacyPolicy: 'Les vår personvernpolicy',
  cookiePolicy: 'Informasjonskapselspolicy',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI-gjennomgang',
  aiDraft: 'AI-utkast',
  smartAssistant: 'Mal',

  // 知识库搜索
  enableKnowledgeSearch: 'Aktiver søk',
  knowledgeSearchDesc: 'AI søker i dokumentene dine',
  clickToDisable: 'Deaktiver',
  clickToEnable: 'Aktiver',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Lukk ressurspanel',
  uploading: 'Laster opp %{fileName}...',
  processing: 'Behandler %{fileName}...',
  uploadSuccess: '✓ %{fileName} lastet opp',
  uploadError: '✗ Opplasting feilet: %{error}',
  quickAnswer: 'Raskt svar',
  quickAnswerDesc: 'Raskt svar på enkle spørsmål',
  cancelRequest: 'Avbryt',
  library: 'Bibliotek',
  filterAll: 'Alle',
  filterChat: 'Chatter',
  filterReview: 'Gjennomgang',
  filterDraft: 'Utkast',
  filterTemplate: 'Mal',
  filterForm: 'Skjema',
  thinking: 'Tenker...',
  thinkingProcess: 'Tenkeprosess',
  analyzingLegalLogic: 'Analyserer juridisk logikk...',
  lawhelperThinking: 'Lawhelper tenker...',
  serviceError: 'Tjenestefeil',
  uploaded: 'Lastet opp',
  settingsGeneral: 'Generelt',
  settingsNotifications: 'Varsler',
  settingsAppearance: 'Utseende',
  settingsProfile: 'Profil',
  settingsResponseNotifications: 'Svarvarsler',
  settingsResponseNotificationsDesc: 'Varsel når AI er ferdig med svaret',
  settingsColorMode: 'Fargemodus',
  settingsLight: 'Lys',
  settingsDark: 'Mørk',
  settingsSystem: 'System',
  about: 'Om',
  reviewTitle: 'Dokumentgjennomgang',
  exitReview: 'Avslutt gjennomgang',
  uploadPrompt: 'Last opp PDF for gjennomgang',
  uploadButton: 'Velg fil',
  startChatConfig: 'Skriv "Gjennomgå dette dokumentet" for å starte',
  reviewPlaceholder: 'Skriv en melding eller "Gjennomgå dette dokumentet"...',
  analyzing: 'Gjennomgår...',
  reviewComplete: 'Gjennomgang fullført',
  issuesFound: '%{count} problemer funnet',
  draftTitle: 'Juridisk dokumentutforming',
  draftPlaceholder: 'Rediger her eller la AI generere...',
  analyzingTemplate: 'Analyserer mal %{name}...',
  templateAnalyzed: '✅ Mal %{name} analysert! Fortell meg hvordan du vil endre den.',
  templateAnalysisPrompt: 'Analyser nøkkelklausuler i malen',
  parsingFailed: '⚠️ Kunne ikke analysere filen, men du kan beskrive dine behov.',
  generating: 'Genererer...',
  generatedSuccess: '✅ Dokument generert! Se og rediger i editoren.',
  drafterWelcome: 'Velkommen til AI-dokumentassistenten',
  drafterYouCan: 'Du kan:',
  drafterUploadTemplate: 'Laste opp en mal for AI-analyse',
  drafterDescribeNeeds: 'Beskrive dokumentkravene dine',
  drafterLetAiHelp: 'AI hjelper med å skrive kontrakter, avtaler osv.',
  drafterExamples: 'Eksempler:',
  drafterExampleRental: '"Skriv en leieavtale"',
  drafterExampleLabor: '"Fyll ut arbeidsavtalen etter malen"',
  drafterInputPlaceholder: 'Beskriv dokumentbehovene dine...',
  drafterThinking: 'Tenker...',
  drafterHistoryTitle: 'Historikk',
  drafterNoHistory: 'Ingen historikk',
  drafterNewChat: 'Ny chat',
  drafterHistory: 'Historikk',
  drafterRemoveAttachment: 'Fjern vedlegg',
  drafterLineHeight: 'Linjeavstand',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Eksporter som Word (.docx)',
  drafterExportPdf: 'Eksporter som PDF',
  drafterSave: 'Lagre dokument',
  drafterDownload: 'Last ned dokument',
  drafterUndo: 'Angre',
  drafterRedo: 'Gjør om',
  drafterBold: 'Fet',
  drafterItalic: 'Kursiv',
  drafterStrike: 'Gjennomstreket',
  drafterUnderline: 'Understreket',
  drafterHighlight: 'Merk',
  drafterLink: 'Sett inn lenke',
  drafterAlignLeft: 'Venstrejuster',
  drafterAlignCenter: 'Sentrer',
  drafterAlignRight: 'Høyrejuster',
  drafterAlignJustify: 'Blokkjuster',
  drafterList: 'Liste',
  drafterBulletList: 'Punktliste',
  drafterOrderedList: 'Nummerert liste',
  drafterTaskList: 'Oppgaveliste',
  drafterOpenResource: 'Åpne ressurspanel',
  drafterStopGeneration: 'Stopp generering',
  drafterAgentMode: 'Agentmodus aktiv | Klikk for vanlig chat',
  drafterAgentModeOn: 'Agentmodus aktiv | Klikk for vanlig chat',
  drafterAgentModeOff: 'Vanlig chatmodus | Klikk for agentmodus',
  drafterUploadAttachment: 'Last opp vedlegg',
  drafterExit: 'Avslutt',
  drafterConfirm: 'Bekreft',
  drafterOpenLink: 'Åpne lenke',
  drafterDeleteLink: 'Slett lenke',
  drafterQuote: 'Sitat',
  workflowTitle: 'AI-arbeidsflyt',
  workflowRunning: 'Kjører...',
  workflowReady: 'Klar',
  workflowCompleted: 'Fullført',
  workflowStartFailed: 'Arbeidsflyt kunne ikke starte',
  workflowExecutionFailed: 'Arbeidsflyt feilet',
  workflowInterrupted: 'Arbeidsflyt avbrutt',
  workflowProcessing: 'Behandler...',
  workflowStepsCompleted: 'trinn fullført',
  workflowStepsTotal: 'Arbeidsflyt fullført (%{count} trinn)',
  acceptChanges: 'Godta endringer',
  rejectChanges: 'Avvis endringer',
  changesAccepted: 'Endringer godtatt',
  changesRejected: 'Endringer avvist',
  stopWorkflow: 'Stopp',
  restartWorkflow: 'Start på nytt',
  startDrafting: 'Start utforming',
  interrupt: 'Stopp',
  documentSubject: 'Dokumentemne *',
  documentType: 'Dokumenttype',
  jurisdiction: 'Jurisdiksjon',
  specialRequirements: 'Spesielle krav (valgfritt)',
  clickStartDrafting: 'Klikk "Start utforming" for å begynne',
  docTypeContract: 'Kontrakt',
  docTypeAgreement: 'Avtale',
  docTypeNotice: 'Varsel',
  docTypeLetter: 'Brev',
  docTypePetition: 'Begjæring',
  docTypeWill: 'Testament',
  docTypePowerOfAttorney: 'Fullmakt',
  countryChina: 'Kina',
  countryUSA: 'USA',
  countryGermany: 'Tyskland',
  countryJapan: 'Japan',
  countryFrance: 'Frankrike',
  countryUK: 'Storbritannia',
  citationVerified: 'Verifisert',
  citationUnverified: 'Ikke verifisert',
  imageLoadFailed: 'Bildet kunne ikke lastes',
  smartDocTitle: 'Smart dokumentassistent',
  smartDocChatTitle: 'AI-dokumentassistent',
  smartDocDropPrompt: 'Slipp PDF-fil her',
  smartDocSelectFile: 'Velg fil',
  smartDocOr: 'eller',
  smartDocWelcomeTitle: 'Velkommen til AI-dokumentassistenten',
  smartDocWelcomeYouCan: 'Du kan:',
  smartDocUploadForAI: 'Laste opp mal for AI-analyse',
  smartDocDescribeDoc: 'Beskrive dokumentkrav',
  smartDocLetAIDraft: 'AI hjelper med kontrakter',
  smartDocExamples: 'Eksempler:',
  smartDocExampleRental: '"Skriv en leieavtale"',
  smartDocExampleLabor: '"Fyll ut arbeidsavtalen"',
  smartDocInputPlaceholder: 'Beskriv dokumentbehovene...',
  smartDocRemoveAttachment: 'Fjern vedlegg',
  smartDocOpenResources: 'Åpne ressurspanel',
  smartDocExit: 'Avslutt',
  reviewStartFailed: 'Gjennomgangsarbeidsflyt feilet',
  reviewFailed: 'Gjennomgang feilet',
  reviewFoundIssues: 'Gjennomgang fullført, %{count} problemer funnet.',
  cannotReadStream: 'Kan ikke lese svarstrømmen',
  parseEventFailed: 'Kunne ikke analysere hendelse',
  errorPrefix: 'Feil',
  unknownError: 'Ukjent feil',
  file: 'Fil',
  loading: 'Laster...',
  localFolders: 'Lokale mapper',
  selectLocalFolder: 'Velg lokal mappe',
  reselectFolder: 'Bytt mappe',
  addToContext: 'Legg til i chat',
  saveFile: 'Lagre',
  renameFile: 'Gi nytt navn',
  fileSaved: 'Fil lagret',
  fileRenamed: 'Fil omdøpt til %{name}',
  browserNotSupported: 'Nettleseren din støtter ikke lokal mappetilgang',
  noFolderSelected: 'Velg en lokal mappe for å bla gjennom filer',
  scanningFolder: 'Skanner mappe...',
  selectFileToPreview: 'Velg fil for forhåndsvisning',
  aiAnalyze: 'AI-analyse',
};
